import { ParentChildValues } from "PFApp/helpers/get_parent_child_skills_map";

import { Activity } from "./activity";
import { RemoveAll } from "./common";
import { ActivityCustomField } from "./custom_field";
import { CustomValueActivityConnection } from "./custom_value";
import { Id } from "./id";

export enum CustomValueScope {
  Unscoped,
  Profile,
  Activity
}

type CustomValuePreviewBase = {
  customTypeId: Id;
  canEdit?: boolean;
  canRemove?: boolean;
  connectedValuesIds?: Id[];
  parentChildProfileValues?: ParentChildValues;
  key?: string;
  onReopen?: VoidFunction;
};

type CustomValueParamsConditional =
  | {
      isNew?: false;
      allowSearch?: false;
      customValueId: Id;
    }
  | {
      isNew: true;
      allowSearch: true;
      customValueId?: never;
    }
  | {
      isNew: true;
      allowSearch?: false;
      customValueId: Id;
    };

type CommonActivityScopeParams = {
  staticActivityConnection?: Pick<CustomValueActivityConnection, "importance" | "requiredExperience">;
  onSave?: (newCustomFields: ActivityCustomField[]) => void;
  onRemove?: (newCustomFields: ActivityCustomField[]) => void;
};

type ActivityScopeParamsConditional = CommonActivityScopeParams &
  (
    | {
        scope: CustomValueScope.Activity;
        activityId: Id;
        profileId?: Id;
        staticActivity?: never;
        isUnbiasedMode?: never;
      }
    | {
        scope: CustomValueScope.Activity;
        staticActivity: Pick<Activity, "template_id" | "profile" | "custom_fields"> & Partial<Activity>;
        activityId?: never;
        profileId?: Id;
        isUnbiasedMode?: never;
      }
  );

type ProfileScopeParams = {
  scope: CustomValueScope.Profile;
  profileId: Id;
  activityId?: never;
  staticActivity?: never;
  isUnbiasedMode?: boolean;
} & RemoveAll<CommonActivityScopeParams>;

type ScopeParams = ActivityScopeParamsConditional | ProfileScopeParams;

export type CustomValuePreview = CustomValuePreviewBase & CustomValueParamsConditional & ScopeParams;
